var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-page-shell" },
    [
      _c("store-index", {
        attrs: {
          "biz-type": 2,
          "create-or-edit-url": "/pointsStore/list/creatProduct",
          "detail-url": "/pointsStore/list/productDetail",
          "inventory-adjust-url": "/pointsStore/list/inventoryAdjust",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }